import type { AIRecommendation } from '../../productintel/framework';
import { Button } from '../ui/Button';
import { ConfidenceIndicator } from '../ui/ConfidenceIndicator';

type Props = {
  recommendations?: AIRecommendation[];
};

export function AIRecommendationsPanel({ recommendations = [] }: Props) {
  return (
    <div className="space-y-3">
      {recommendations.map((rec) => (
        <div
          key={rec.title}
          className="flex items-start justify-between gap-3 rounded-lg border border-slate-200 p-3 dark:border-slate-700"
        >
          <div className="min-w-0">
            <div className="flex items-center gap-2">
              <span className="rounded bg-ai-100 px-1.5 py-0.5 text-xs font-medium text-ai-700 dark:bg-ai-950 dark:text-ai-300">
                {rec.type}
              </span>
              <ConfidenceIndicator score={rec.confidence / 100} size="sm" />
            </div>
            <p className="mt-1 text-sm font-medium">{rec.title}</p>
            <p className="text-xs text-success-600">{rec.impact}</p>
          </div>
          <Button variant="secondary" size="sm">Apply</Button>
        </div>
      ))}
    </div>
  );
}
